import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '../../atoms';

const StyledButton = styled.button.attrs({ type: 'button' })`
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-self: center;
`;

const StyledIcon = styled(Icon)`
  color: var(--content-subtitle);
  transition: color 0.1s linear;

  ${StyledButton}:hover & {
    color: var(--gray-700);
  }
`;

const SidebarToggleButton = ({ className = null, collapsed = false, onClick }) => (
  <StyledButton onClick={onClick} className={className}>
    <StyledIcon name={collapsed ? 'sidebar-expand' : 'sidebar-collapse'} />
  </StyledButton>
);

SidebarToggleButton.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export { SidebarToggleButton };
